import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Catalog from './components/Catalog/Catalog';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Links from './components/Links/Links';
import WhatsAppFloat from './components/WhatsAppFloat/WhatsAppFloat';

function Home() {
  return (
    <div className="App">
      <Navbar />
      <div className="sections-container">
        <Hero />
        <Catalog />
        <About />
        <Contact />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/links" element={<Links />} />
      </Routes>
      <WhatsAppFloat />
    </Router>
  );
}

export default App;